import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import PropTypes from 'prop-types'
import flatten from 'lodash/flatten'

import ProgressBarIndicator from '@components/ProgressBarIndicator'

class Statistics extends Component {
  static propTypes = {
    deliverableStore: PropTypes.object,
    projectStore: PropTypes.object
  }

  calculateFees = () => {
    let feeCost = []
    let feeFee = []
    let amountCost = 0
    let amountFee = 0

    const list = toJS(this.props.deliverableStore.deliverables)
    const fees = flatten(list.map(deliverable => deliverable.fees))

    fees.forEach(fee => {
      fee.feeItems.forEach(feeItem => {
        if (feeItem.costTypeId) {
          feeCost.push(feeItem)
          amountCost += feeItem.converted
        } else {
          feeFee.push(feeItem)
          amountFee += feeItem.converted
        }
      })
    })

    const data = {
      feeCost,
      feeFee,
      amountCost,
      amountFee
    }

    return data
  }

  render () {
    const { project } = this.props.projectStore
    const { statistics } = this.props.deliverableStore
    const fees = this.calculateFees()
    const feesLengthOk = fees.feeFee.length > 0

    if (!statistics) return null

    return (
      <div className='progress-bar-groups'>
        <div className='progress-bar-groups__single'>
          <ProgressBarIndicator
            label='Interviews / Target'
            delivered={statistics.numberOfChargedInterviews}
            target={project.interviewTarget}
            theme='blue'
          />

          <ProgressBarIndicator
            label='Gross margin'
            value={statistics.grossMargin.value + ' €'}
            percent={statistics.grossMargin.percent}
            sideValue={parseFloat(
              statistics.grossMargin.percent
                ? `${statistics.grossMargin.percent}%`
                : 'N/A'
            )}
            theme='blue'
          />
        </div>
        <div className='progress-bar-groups__single'>
          <ProgressBarIndicator
            label='Fees'
            percent={feesLengthOk ? 100 : 0}
            sideValue={fees.feeFee.length}
            value={fees.amountFee.toFixed(2) + ' €'}
            theme='green'
          />

          <ProgressBarIndicator
            label='Costs'
            percent={(fees.amountCost / fees.amountFee) * 100}
            sideValue={fees.feeCost.length}
            value={fees.amountCost.toFixed(2) + ' €'}
            theme='red'
          />
        </div>
      </div>
    )
  }
}

export default inject('deliverableStore', 'projectStore')(observer(Statistics))
